<header
  class="title-action-bar notification"
>
  <h2 class="title-action-bar__title">
    {{ text }}
  </h2>

  <aside class="title-action-bar__action">
    @if (lastUpdate) {
      <h6 class="title-action-bar__last-update">
        Última atualização em {{ lastUpdate | date:'dd/MM/yyyy HH:mm:ss' }}
      </h6>
    }

    <p class="title-action-bar__opf-disclaimer">{{ opfDisclaimer }}</p>
  </aside>
</header>
